import React ,{Component} from "react";
import Link from "gatsby-link";
import UserAvathar from '../components/userAvathar/userAvathar.js';
import UserName from '../components/userName/userName.js';
import Subheading from '../components/userSubhead/userSubhead.js';
import NavigationList from '../components/navigationMenu/navigationList.js';
import SocialLinks from '../components/socialLinks/socialLinks.js';
import Footer from "../components/footer/footer.js";
import ScrollUp from '../components/moveupButton/ScrollUp.js';

import './commonStyle.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css'; 
import scrollToComponent from 'react-scroll-to-component';


class SiteLayout extends React.Component{
  constructor(){
    super();
    this.state={
      showMoveupButton:false,
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount(){
    window.addEventListener('scroll', this.handleScroll);
  }
  handleScroll(e){
    if(e.target.scrollingElement.scrollTop>570){
      this.setState({stickButton:true});
    }else{
      this.setState({stickButton:false});
    }
    if(e.target.scrollingElement.scrollTop>380){
      this.setState({showMoveupButton:true})
    }else{
      this.setState({showMoveupButton:false})
    }
    
  }
  scrolltoHome(){
    scrollToComponent(this.Home, { offset:0, align: 'top', duration: 700});
  }
  render(){
    return(
      <div className="" ref={(section) => { this.Home = section; }}>
        <div className="page_layout_container">
          
        </div>
        {this.state.showMoveupButton && <ScrollUp stickButton={this.state.stickButton} scrollHome={this.scrolltoHome.bind(this)}/>}
        <div className="container_centered">
          <div className="container_menu">
              <UserAvathar/>
              <UserName/>
              <Subheading/>
              <NavigationList/>
              <SocialLinks/>
          </div>
          <div className="container_content" ref={(section) => { this.Container = section; }} >
              {this.props.children()}
              <div className="gatsby-footer-mobile">© {(new Date()).getFullYear()} - All Rights Reserved <br /> boris@livshutz.com </div>
              <Footer/>
          </div>
        </div>
      </div>
    )
  }
}
export default SiteLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js